import { render } from "./shinsei_Remoteworkedit.vue?vue&type=template&id=2b7cc85a&scoped=true&ts=true"
import script from "./shinsei_Remoteworkedit.vue?vue&type=script&lang=ts"
export * from "./shinsei_Remoteworkedit.vue?vue&type=script&lang=ts"

import "./shinsei_Remoteworkedit.vue?vue&type=style&index=0&id=2b7cc85a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b7cc85a"]])

export default __exports__